export default "__VITE_ASSET__CqEW15MI__"